import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicForm from "@/pages/PublicForm";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AdminPanel from "@/pages/AdminPanel";
import RatePage from "@/pages/RatePage";
import ProfilePage from "@/pages/ProfilePage";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import { useLocation } from "react-router-dom";

function Protected({ children, adminOnly = false }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-lg font-semibold" data-testid="auth-loading">
        Checking session…
      </div>
    );
  }
  if (!user) return <Navigate to="/team-login" replace />;
  if (user.must_change_password && pathname !== "/team/profile") return <Navigate to="/team/profile" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/team" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicForm />} />
            <Route path="/rate" element={<RatePage />} />
            <Route path="/team-login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/team/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="/team/login" element={<Navigate to="/team-login" replace />} />
            <Route path="/team" element={<Protected><Dashboard /></Protected>} />
            <Route path="/team/admin" element={<Protected adminOnly><AdminPanel /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
